(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fundraising-validation-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function initToggle() {
      var toggleBtns = document.querySelectorAll('.fundraising-modal__toggle-btn');
      var idInput = document.getElementById('fundraising-id');
      var idLabel = document.querySelector('[data-id-label]');
      var sellerNameFields = document.getElementById('seller-name-fields');
      var sellerLastNameField = document.getElementById('seller-last-name-field');

      if (!toggleBtns.length || !idInput) return;

      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggleBtns.forEach(function (b) { b.classList.remove('fundraising-modal__toggle-btn--active'); });
          btn.classList.add('fundraising-modal__toggle-btn--active');

          var idType = btn.getAttribute('data-id-type');
          if (idType === 'seller') {
            if (idLabel) idLabel.innerHTML = 'Seller ID# <span class="required" aria-hidden="true">*</span>';
            if (idInput) idInput.placeholder = 'Enter your Seller ID#';
            if (sellerNameFields) sellerNameFields.style.display = 'none';
            if (sellerLastNameField) sellerLastNameField.style.display = 'none';
          } else {
            if (idLabel) idLabel.innerHTML = 'Group ID# <span class="required" aria-hidden="true">*</span>';
            if (idInput) idInput.placeholder = 'e.g. 10-0511';
            if (sellerNameFields) sellerNameFields.style.display = '';
            if (sellerLastNameField) sellerLastNameField.style.display = '';
          }

          idInput.value = '';
          var errorEl = document.querySelector('[data-error-message]');
          if (errorEl) errorEl.textContent = '';
          idInput.classList.remove('error');
        });
      });
    }

    if (window.FundraisingValidationInitialized) return;

    function initWhenReady() {
      if (window.FundraisingValidationInitialized) return;
      if (window.FundraisingValidation) {
        window.fundraisingValidator = new window.FundraisingValidation();
        window.FundraisingValidationInitialized = true;
      } else {
        setTimeout(initWhenReady, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initToggle();
        initWhenReady();
      });
    } else {
      initToggle();
      initWhenReady();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
